import type { CSSProperties, ReactNode } from 'react';
import { useMemo } from 'react';
import clsx from 'clsx';
import styles from './FolderMediaContainer.module.css';

export type FolderMediaContainerProps = {
  children?: ReactNode;
  /** The fixed height of the folder media container */
  height: number;
  isCompact?: boolean;
  /** The fixed width of the folder media container */
  width: number;
};

/**
 * This component is used to display the media for a folder in the quick search list.
 * On mobile, it is used to display the folder thumbnail.
 * On desktop, it is used to display the folder thumb with a gradient overlay.
 */
export const FolderMediaContainer = ({
  children,
  height,
  isCompact = false,
  width,
}: FolderMediaContainerProps) => {
  const style = useMemo(
    () =>
      ({
        '--media-height': `${height}px`,
        '--media-width': `${width}px`,
      }) as CSSProperties,
    [height, width]
  );

  return (
    <div
      className={clsx(styles.container, { [styles.compact]: isCompact })}
      style={style}
    >
      {children}
    </div>
  );
};
